export const SET_SHOW_ADMAN_ADS = 'SET_SHOW_ADMAN_ADS'
